import { lazy, type ComponentType } from 'react';

/**
 * A page loaded only when its route is opened (App.tsx).
 *
 * When a tab outlived a deploy and the chunk is gone, Vite fires
 * `vite:preloadError`; `staleChunkReload` cancels it and reloads, and the
 * import then resolves with `undefined`. React.lazy would throw on that and
 * flash the error page before the reload lands, so wait instead: the Suspense
 * spinner stays up until the page is replaced. A chunk that is really missing
 * (a second failure inside the reload guard) is not cancelled, rejects, and
 * reaches the ErrorBoundary as before.
 */
export function lazyPage<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(() => load().then((m) => m ?? new Promise<never>(() => {})));
}
